/** Thumbnail URL with onerror fallback handled in VideoCard. */
export function thumb(id, q = "maxresdefault") {
  return `https://img.youtube.com/vi/${id}/${q}.jpg`;
}

export function yt(id, short = false) {
  return short
    ? `https://www.youtube.com/shorts/${id}`
    : `https://www.youtube.com/watch?v=${id}`;
}

export function isMobile() {
  if (typeof window === "undefined") return false;
  return window.innerWidth < 768 || /Mobi|Android/i.test(navigator.userAgent);
}

export function formatViews(n) {
  if (!n) return "";
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M views`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(0)}K views`;
  return `${n} views`;
}

export function timeAgo(dateStr) {
  if (!dateStr) return "";
  const diff = Date.now() - new Date(dateStr).getTime();
  const days = Math.floor(diff / 86400000);
  if (days < 1) return "Today";
  if (days < 7) return `${days}d ago`;
  if (days < 30) return `${Math.floor(days / 7)}w ago`;
  if (days < 365) return `${Math.floor(days / 30)}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}

export function videoMeta(video) {
  const parts = [];
  if (video?.viewCount) parts.push(formatViews(video.viewCount));
  if (video?.publishedAt) parts.push(timeAgo(video.publishedAt));
  return parts.length ? parts.join(" · ") : "";
}

/* ════════════════════════════════════════
   Global "only one iframe at a time" state
   ════════════════════════════════════════ */

let activeEmbedId = null;
const embedCallbacks = new Map();

export function claimEmbed(id) {
  if (activeEmbedId && activeEmbedId !== id) {
    const prev = embedCallbacks.get(activeEmbedId);
    if (prev) prev();
  }
  activeEmbedId = id;
}

export function releaseEmbed(id) {
  if (activeEmbedId === id) activeEmbedId = null;
}

export function registerEmbed(id, stop) {
  embedCallbacks.set(id, stop);
  return () => embedCallbacks.delete(id);
}
